import { Api } from "@/api"
import type { Company, Id } from "@/models"
import { arrayToMap } from "@/utils/arrayToMap"
import { toReactive } from "@vueuse/core"
import { defineStore } from "pinia"
import { toRef } from "vue"
import { ensureLoadingHasResult, piniaLoadableState } from "vue-utils"

async function loadCompanies() {
	const companies = await Api.companies.list()
	return arrayToMap(companies)
}

export const useCompaniesStore = defineStore("companies", {
	state: () => piniaLoadableState(loadCompanies),
	actions: {
		getCompanies(): Map<Id, Company> {
			return ensureLoadingHasResult(this)
		},
		async createCompany(company: Company) {
			const newCompany = await Api.companies.create(company)
			this.getCompanies().set(newCompany.id, newCompany)
		},

		async updateCompany(company: Company) {
			const updatedCompany = await Api.companies.update(company)
			this.getCompanies().set(updatedCompany.id, updatedCompany)
		},
		async deleteCompany(company: Id | Company) {
			const id = typeof company === "number" ? company : company.id
			await Api.companies.delete(id)
			this.getCompanies().delete(id)
		},
	},
})

export function useCompanies(): Map<Id, Company> {
	const store = useCompaniesStore()
	return toReactive(toRef(() => store.getCompanies()))
}
